import React, { useState, useEffect, useCallback } from 'react';

import Lottie from 'react-lottie';
import animationData from './lottie.json';

import { Gradient } from '~/components';

import { Container, Content, Message, SubMessage, Back } from './styles';

import { SessionProps } from './interface';

const Session: React.FC<SessionProps> = ({ isPrivate, children }) => {
  const [visibilidade, setVisibilidade] = useState(false);

  const voltarAoLogin = () => {};

  const checarExpiracao = useCallback(() => {
    if (isPrivate) {
      const token = localStorage.getItem('@milvio:token');
      if (!token || token == null) {
        setVisibilidade(true);
      }
    }
  }, [isPrivate]);

  useEffect(() => {
    window.addEventListener('storage', checarExpiracao, false);
  }, [checarExpiracao]);

  if (isPrivate && visibilidade) {
    return (
      <Gradient>
        <Container>
          <Content>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: animationData,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
              height={400}
              width={400}
            />

            <Message>SUA SESSÃO EXPIROU!</Message>
            <SubMessage>Volte ao login e entre no app novamente.</SubMessage>
            <div>
              <Back onClick={voltarAoLogin}>VOLTAR</Back>
            </div>
          </Content>
        </Container>
      </Gradient>
    );
  }

  return <>{children}</>;
};

export default Session;
